import image_logo from "../../assets/images/truhail_favicon.svg";
import {
  PROVIDER,
  OPERATOR,
  controllerLine,
  providerRoleSentence,
} from "../../config/legalEntities";

function PrivacyPolicyDriver() {
  const appName = process.env.REACT_APP_NAME || "TruHail";
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 py-10">
      <div className="mb-8 h-[80px] overflow-hidden rounded-2xl">
        <img
          src={image_logo}
          alt={`Logo ${appName}`}
          height={80}
          className="h-full w-full object-cover"
        />
      </div>

      <div className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-md">
        <h1 className="mb-4 text-2xl font-bold">
          Política de Privacidade — Motoristas
        </h1>
        <p className="mb-6 text-sm text-gray-500">
          Última atualização: 26 de fevereiro de 2026
        </p>
        <p className="mb-8 text-lg">
          Esta Política de Privacidade descreve como coletamos, utilizamos,
          compartilhamos e protegemos suas informações pessoais no aplicativo{" "}
          {appName} Motoristas. Ao utilizar nossos serviços, você concorda com
          os termos aqui descritos.
        </p>

        <div className="mb-6 rounded-lg bg-blue-50 p-4">
          <h3 className="mb-2 font-semibold text-blue-800">
            Sobre a estrutura de responsabilidades
          </h3>
          <p className="text-sm text-blue-700">
            O aplicativo {appName} é fornecido como plataforma tecnológica
            (SaaS) por <strong>{PROVIDER.name}</strong> (CNPJ {PROVIDER.cnpj})
            e operado comercialmente pela{" "}
            <strong>{OPERATOR.name}</strong> (licenciada whitelabel). Conforme
            as Leis de Proteção de Dados Aplicáveis (incluindo a LGPD — Lei nº
            13.709/2018), a Controladora dos dados dos motoristas e passageiros
            é <strong>{controllerLine}</strong>. {providerRoleSentence}
          </p>
        </div>

        <div className="space-y-8">
          {/* 1. Dados Coletados */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">1. Dados Coletados</h2>
            <ul className="list-inside list-disc space-y-1">
              <li>
                <strong>Dados Pessoais:</strong> Nome completo, e-mail,
                telefone, foto de perfil
              </li>
              <li>
                <strong>Documentos:</strong> CNH (Carteira Nacional de
                Habilitação), CRLV (Certificado de Registro e Licenciamento de
                Veículo), certidões de antecedentes criminais
              </li>
              <li>
                <strong>Dados do Veículo:</strong> Placa, modelo, ano, cor, foto
              </li>
              <li>
                <strong>Dados Financeiros:</strong> Saldo da carteira digital,
                extrato de comissões, dados bancários ou de conta de pagamento
                para saques
              </li>
              <li>
                <strong>Dados de Operação:</strong> Localização em tempo real
                (quando online), histórico de corridas, avaliações recebidas,
                métricas de desempenho
              </li>
              <li>
                <strong>Dados Técnicos:</strong> Identificador do dispositivo,
                sistema operacional, versão do aplicativo, endereço IP
              </li>
            </ul>
          </div>

          {/* 2. Finalidades e Bases Legais */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">
              2. Finalidades e Bases Legais
            </h2>
            <ul className="list-inside list-disc space-y-1">
              <li>
                <strong>Execução de Contrato (Art. 7º V LGPD):</strong>{" "}
                Operação de corridas, pagamentos, gestão da carteira digital e
                cálculo de comissões
              </li>
              <li>
                <strong>Consentimento (Art. 7º I LGPD):</strong> Coleta de
                localização em tempo real durante a operação; envio de
                notificações push; verificação de antecedentes
              </li>
              <li>
                <strong>Obrigação Legal (Art. 7º II LGPD):</strong>{" "}
                Compartilhamento com autoridades mediante ordem judicial;
                retenção de dados fiscais e trabalhistas
              </li>
              <li>
                <strong>Legítimo Interesse (Art. 7º IX LGPD):</strong>{" "}
                Prevenção à fraude, segurança nas operações, verificação de
                documentos, melhorias do serviço
              </li>
            </ul>
          </div>

          {/* 3. Compartilhamento de Dados */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">
              3. Compartilhamento de Dados
            </h2>
            <ul className="list-inside list-disc space-y-1">
              <li>
                Com passageiros durante a corrida (nome, foto, placa do veículo,
                localização em tempo real)
              </li>
              <li>
                Com a Provedora da Plataforma para manutenção e operação do
                sistema
              </li>
              <li>
                Com instituições financeiras e provedores de pagamento para
                repasse de valores
              </li>
              <li>
                Com autoridades competentes mediante solicitação legal válida
              </li>
            </ul>

            <div className="mt-4">
              <h3 className="mb-2 font-semibold">
                3.1 Serviços de Terceiros Utilizados
              </h3>
              <p className="mb-2 text-sm text-gray-600">
                A Plataforma utiliza os seguintes serviços de terceiros para
                funcionamento. Cada serviço possui sua própria política de
                privacidade:
              </p>
              <ul className="list-inside list-disc space-y-2">
                <li>
                  <strong>Mercado Pago</strong>: Processamento de pagamentos
                  online, split de valores e repasses financeiros (
                  <a
                    href="https://www.mercadopago.com.br/privacidade"
                    className="text-blue-600 underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política do Mercado Pago
                  </a>
                  )
                </li>
                <li>
                  <strong>OneSignal</strong>: Envio de notificações push (
                  <a
                    href="https://onesignal.com/privacy"
                    className="text-blue-600 underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política do OneSignal
                  </a>
                  )
                </li>
                <li>
                  <strong>SendPulse</strong>: Envio de e-mails transacionais e
                  SMS (
                  <a
                    href="https://sendpulse.com/legal/privacy"
                    className="text-blue-600 underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política do SendPulse
                  </a>
                  )
                </li>
                <li>
                  <strong>OpenStreetMap</strong> e <strong>CARTO</strong>: Mapas,
                  geocodificação e visualização de trajetos (
                  <a
                    href="https://wiki.osmfoundation.org/wiki/Privacy_Policy"
                    className="text-blue-600 underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política da OpenStreetMap Foundation
                  </a>{" "}
                  e{" "}
                  <a
                    href="https://carto.com/privacy"
                    className="text-blue-600 underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política da CARTO
                  </a>
                  )
                </li>
              </ul>
              <p className="mt-3 text-sm text-gray-600">
                A lista completa e atualizada de provedores e subprocessadores,
                com suas finalidades e políticas aplicáveis, está detalhada na
                seção <strong>&ldquo;Provedores e Subprocessadores&rdquo;</strong>{" "}
                abaixo.
              </p>
            </div>
          </div>

          {/* 3.2 Provedores e Subprocessadores */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">
              Provedores e Subprocessadores
            </h2>
            <p className="mb-3">
              Para operar a plataforma, compartilhamos apenas os dados
              estritamente necessários com os subprocessadores abaixo, cada um
              limitado à finalidade indicada. Cada provedor possui sua própria
              política de privacidade:
            </p>
            <ul className="list-inside list-disc space-y-2">
              <li>
                <strong>Mercado Pago</strong> — Processamento de pagamentos,
                split de valores e repasses (
                <a
                  href="https://www.mercadopago.com.br/privacidade"
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidade
                </a>
                )
              </li>
              <li>
                <strong>OneSignal</strong> — Notificações push (
                <a
                  href="https://onesignal.com/privacy"
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidade
                </a>
                )
              </li>
              <li>
                <strong>SendPulse</strong> — Envio de SMS e e-mail (
                <a
                  href="https://sendpulse.com/legal/privacy"
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidade
                </a>
                )
              </li>
              <li>
                <strong>OpenStreetMap</strong> — Mapas e geocodificação (
                <a
                  href="https://wiki.osmfoundation.org/wiki/Privacy_Policy"
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidade
                </a>
                )
              </li>
              <li>
                <strong>CARTO</strong> — Mapas (
                <a
                  href="https://carto.com/privacy"
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidade
                </a>
                )
              </li>
              <li>
                <strong>Firebase/Google</strong> — Hospedagem e infraestrutura (
                <a
                  href="https://policies.google.com/privacy"
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidade
                </a>
                )
              </li>
              <li>
                <strong>Apple App Store</strong> — Distribuição do aplicativo (
                <a
                  href="https://www.apple.com/legal/privacy/"
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidade
                </a>
                )
              </li>
              <li>
                <strong>Google Play</strong> — Distribuição do aplicativo (
                <a
                  href="https://policies.google.com/privacy"
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidade
                </a>
                )
              </li>
              <li>
                <strong>OpenAI</strong> — Apenas análise agregada e anônima, sem
                dados pessoais identificáveis (PII) (
                <a
                  href="https://openai.com/policies/privacy-policy"
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidade
                </a>
                )
              </li>
            </ul>
            <p className="mt-3">
              <strong>Documentos de verificação (KYC):</strong> seus documentos
              de habilitação (CNH), comprovante de endereço e certidões de
              antecedentes criminais são tratados exclusivamente para fins de
              verificação cadastral e de segurança, e são apagados na exclusão da
              sua conta, observados os prazos legais de retenção aplicáveis.
            </p>
            <p className="mt-3 text-sm text-gray-600">
              As URLs e versões das políticas de terceiros podem mudar; confira
              na data de acesso. Para exercer seus direitos ou esclarecer
              dúvidas sobre subprocessadores, contate nosso Encarregado de
              Proteção de Dados (DPO):{" "}
              <a
                href="mailto:dpo@trusom.com"
                className="text-blue-600 underline"
              >
                dpo@trusom.com
              </a>
              .
            </p>
          </div>

          {/* 4. Retenção e Exclusão */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">
              4. Retenção e Exclusão de Dados
            </h2>
            <ul className="list-inside list-disc space-y-1">
              <li>
                Documentos (CNH, CRLV): 5 anos após desativação da conta
              </li>
              <li>
                Dados financeiros: 10 anos (Lei nº 12.846/2013 e obrigações
                fiscais)
              </li>
              <li>Dados de localização: 90 dias</li>
              <li>Histórico de corridas: 3 anos para fins de reclamações</li>
              <li>
                Dados de conta: Anonimizados após exclusão, conforme processo de
                anonimização previsto na legislação
              </li>
              <li>
                Solicitações de exclusão:{" "}
                <a
                  href="mailto:software@trusom.com"
                  className="text-blue-600 underline"
                >
                  software@trusom.com
                </a>{" "}
                ou via funcionalidade de exclusão de conta no aplicativo
              </li>
            </ul>
          </div>

          {/* 5. Segurança */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">
              5. Medidas de Segurança
            </h2>
            <ul className="list-inside list-disc space-y-1">
              <li>Criptografia em trânsito (TLS/SSL)</li>
              <li>Controle de acesso baseado em funções (RBAC)</li>
              <li>Armazenamento seguro de documentos</li>
              <li>Anonimização de dados sensíveis ao excluir contas</li>
              <li>Monitoramento contínuo de acessos e logs de auditoria</li>
              <li>Backups periódicos com criptografia</li>
              <li>Limitação de taxa (rate-limiting) para prevenção de abuso</li>
            </ul>
          </div>

          {/* 6. Direitos do Titular */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">
              6. Seus Direitos como Titular de Dados
            </h2>
            <p className="mb-2">
              Conforme a legislação de proteção de dados aplicável, você tem
              direito a:
            </p>
            <ul className="list-inside list-disc space-y-1">
              <li>
                <strong>Acesso:</strong> Solicitar cópia dos dados pessoais que
                mantemos sobre você
              </li>
              <li>
                <strong>Correção:</strong> Solicitar a correção de dados
                incorretos ou desatualizados
              </li>
              <li>
                <strong>Eliminação:</strong> Solicitar a exclusão dos seus dados
                pessoais
              </li>
              <li>
                <strong>Portabilidade:</strong> Solicitar a transferência dos
                seus dados para outro serviço
              </li>
              <li>
                <strong>Oposição:</strong> Opor-se ao tratamento de dados
                baseado em legítimo interesse
              </li>
              <li>
                <strong>Revogação de consentimento:</strong> Retirar o
                consentimento dado anteriormente, sem afetar a legalidade do
                tratamento já realizado
              </li>
            </ul>
            <p className="mt-2">
              Solicitações:{" "}
              <a
                href="mailto:software@trusom.com"
                className="text-blue-600 underline"
              >
                software@trusom.com
              </a>
            </p>
          </div>

          {/* 7. Transferência Internacional */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">
              7. Transferência Internacional de Dados
            </h2>
            <p>
              Alguns dos serviços de terceiros listados na seção 3.1 podem
              armazenar ou processar dados fora do país. Nestes casos, garantimos
              que a transferência atende às exigências da legislação de proteção
              de dados aplicável, incluindo a adoção de cláusulas contratuais
              padrão ou outras salvaguardas adequadas.
            </p>
          </div>

          {/* 8. Encarregado de Dados */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">
              8. Encarregado de Dados (DPO)
            </h2>
            <p>
              Contato do Encarregado de Proteção de Dados:{" "}
              <a
                href="mailto:dpo@trusom.com"
                className="text-blue-600 underline"
              >
                dpo@trusom.com
              </a>
            </p>
          </div>

          {/* 9. Alterações */}
          <div>
            <h2 className="mb-3 text-xl font-semibold">
              9. Alterações desta Política
            </h2>
            <p>
              Atualizações desta Política serão comunicadas pelo aplicativo e/ou
              e-mail. A continuidade do uso após a comunicação constitui aceite
              das alterações.
            </p>
          </div>

          {/* Links relacionados */}
          <div className="border-t border-gray-200 pt-6">
            <h3 className="mb-2 font-semibold">Documentos Relacionados</h3>
            <ul className="list-inside list-disc space-y-1">
              <li>
                <a
                  href="/terms-driver"
                  className="text-blue-600 underline"
                >
                  Termos e Condições de Uso — Motoristas
                </a>
              </li>
              <li>
                <a
                  href="/privacy-policy-rider"
                  className="text-blue-600 underline"
                >
                  Política de Privacidade — Passageiros
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyDriver;
